import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

export const classNames = (...classes: (false | null | undefined | string)[]): string => {
  return cn(...classes);
};
